/**
 * Included into the footer of pages.
 */

import * as variables from './variables';

import './lib/AnimationEasing';
import "./lib/AnalyticsSetup";

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu } from './component/MainMenu';
new MainMenu({
	menuID: 'menu',
	toggles: '.menuToggle',
	focusLock: {
		dialog: '.menu',
		return: '.menuToggle--open',
		toggle: '.menuToggle--close'
	},
	styleClass: {
		menuOpen: 'hasMenuOpen'
	},
	duration: 400,
	easing: 'easeOutExpo'
});

// Heading Echo
const echos = document.querySelectorAll(".wp-block-heading.is-style-echo");
echos.forEach(element => {
	let echo = document.createElement('DIV');
	echo.setAttribute('data-echo', element.innerHTML);
	echo.setAttribute('aria-hidden', 'true');
	element.appendChild(echo);
});

import {videoModals} from "./component/VideoModal/VideoModal";
videoModals({
	// If you want a custom play button, uncomment this line
	// customPlayButton: require("./component/VideoModal/VideoModal.svg?string")
});